const ANNOUNCEMENT_HEIGHT_VAR = '--vaillant-announcement-height';

function getAnnouncementBar() {
  return document.querySelector('.announcement-bar-vaillant:not(.is-dismissed):not([hidden])');
}

function setAnnouncementHeight() {
  const bar = getAnnouncementBar();
  const height = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
  document.documentElement.style.setProperty(ANNOUNCEMENT_HEIGHT_VAR, `${height}px`);
}

function syncAnnouncementScroll() {
  const bar = getAnnouncementBar();
  const header = document.querySelector('.section-header');
  const scrolledAway = Boolean(bar && bar.getBoundingClientRect().bottom <= 0);

  header?.classList.toggle('announcement-scrolled', scrolledAway);
  document.documentElement.style.setProperty(
    ANNOUNCEMENT_HEIGHT_VAR,
    scrolledAway ? '0px' : `${bar ? Math.ceil(bar.getBoundingClientRect().height) : 0}px`
  );
}

class AnnouncementBarVaillant extends HTMLElement {
  connectedCallback() {
    this.storageKey = this.dataset.storageKey;
    this.closeButton = this.querySelector('[data-announcement-close]');

    if (this.storageKey && sessionStorage.getItem(this.storageKey) === 'dismissed') {
      this.dismiss(false);
      return;
    }

    setAnnouncementHeight();
    syncAnnouncementScroll();
    this.closeButton?.addEventListener('click', () => this.dismiss(true));
  }

  dismiss(persist = true) {
    this.setAttribute('hidden', '');
    this.classList.add('is-dismissed');
    syncAnnouncementScroll();

    if (persist && this.storageKey) {
      sessionStorage.setItem(this.storageKey, 'dismissed');
    }

    window.dispatchEvent(new CustomEvent('vaillant:announcement-dismissed'));
  }
}

if (!customElements.get('announcement-bar-vaillant')) {
  customElements.define('announcement-bar-vaillant', AnnouncementBarVaillant);
}

window.addEventListener('resize', syncAnnouncementScroll);
window.addEventListener('scroll', syncAnnouncementScroll, { passive: true });
window.addEventListener('load', syncAnnouncementScroll);
document.addEventListener('DOMContentLoaded', syncAnnouncementScroll);
